import React from 'react'
import { Box } from '@mui/material'
import Refer from '../../../../components/referAndEarn/Refer'

const ReferralTab: React.FC = () => {
  return (
    <Box>
      <Refer type="restaurant" />
    </Box>
  )
}

export default ReferralTab
